import type { MLEvent } from '@/types';

export const mlEvents: MLEvent[] = [
  { month: 'Jan', loss: 0.85, event: '', type: 'normal' },
  { 
    month: 'Feb', 
    loss: 0.82, 
    event: 'Весенние планы', 
    description: 'Notion-табличка критериев к девушке. Кандидаток неясно где брать…',
    emoji: '📋',
    type: 'normal' 
  },
  { 
    month: 'Mar', 
    loss: 0.78, 
    event: '', 
    type: 'normal' 
  },
  { 
    month: 'Apr', 
    loss: 0.75, 
    event: 'Адаптация', 
    description: 'Roadmap по переезду готов. Осталось найти квартиру…',
    emoji: '🏠',
    type: 'descent' 
  },
  { 
    month: 'May', 
    loss: 0.68, 
    event: 'Велосезон открыт', 
    description: 'Девушки это хорошо, но скоро открытие велосезона 😏',
    emoji: '🚴',
    type: 'descent' 
  },
  { 
    month: 'Jun', 
    loss: 0.72, 
    event: 'Охота на квартиру', 
    description: 'Проиграл мужику на дорогой машине. Надо было приехать с личным водителем!',
    emoji: '🚗',
    type: 'spike' 
  },
  { 
    month: 'Jul', 
    loss: 0.65, 
    event: 'Собеседование в ШАД', 
    description: 'Успешно прошёл. Теперь официально умный™',
    emoji: '🎓',
    type: 'normal' 
  },
  { 
    month: 'Aug', 
    loss: 0.58, 
    event: 'Открытие года: аэрогриль', 
    description: 'Овощи-гриль как в ресторанах! Офигенная тема',
    emoji: '🥗',
    type: 'descent' 
  },
  { 
    month: 'Sep', 
    loss: 0.55, 
    event: 'Как оно?', 
    description: '5 кандидаток — и все заняты в субботу вечером. Квартира свободна зря',
    emoji: '💔',
    type: 'normal' 
  },
  { 
    month: 'Oct', 
    loss: 0.72, 
    event: 'Самое месиво', 
    description: '',
    emoji: '⚠️',
    type: 'spike' 
  },
  { 
    month: 'Nov', 
    loss: 0.65, 
    event: 'Стабилизация', 
    description: 'Зал, сауна, планирование',
    emoji: '🧖',
    type: 'descent' 
  },
  { 
    month: 'Dec', 
    loss: 0.52, 
    event: 'День Рождения 🎉', 
    description: '22 лет: новая эпоха',
    emoji: '🎈',
    type: 'normal' 
  },
];

export const trainingLossData = mlEvents.map((e) => ({ month: e.month, loss: e.loss }));
export const validationLossData = mlEvents.map((e) => ({
  month: e.month,
  loss: e.loss + 0.03 + Math.random() * 0.05, // Validation loss slightly higher with variance
}));
